const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:cc": "http://creativecommons.org/ns#",
    "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    width: "4.2036924mm",
    height: "4.2036915mm",
    viewBox: "0 0 4.2036924 4.2036915",
    id: "svg3358",
    "inkscape:version": "0.92.3 (2405546, 2018-03-11)",
    "sodipodi:docname": "checked_icon.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs3352"
  }), /*#__PURE__*/React.createElement("sodipodi:namedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    "inkscape:pageopacity": 0,
    "inkscape:pageshadow": 2,
    "inkscape:zoom": 0.35,
    "inkscape:cx": 7.9439841,
    "inkscape:cy": 7.9439902,
    "inkscape:document-units": "mm",
    "inkscape:current-layer": "layer1",
    showgrid: "false",
    "inkscape:window-width": 2880,
    "inkscape:window-height": 1674,
    "inkscape:window-x": 0,
    "inkscape:window-y": 60,
    "inkscape:window-maximized": 1
  }), /*#__PURE__*/React.createElement("metadata", {
    id: "metadata3355"
  }, /*#__PURE__*/React.createElement("rdf:RDF", null, /*#__PURE__*/React.createElement("cc:Work", {
    "rdf:about": ""
  }, /*#__PURE__*/React.createElement("dc:format", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dc:type", {
    "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dc:title", null)))), /*#__PURE__*/React.createElement("g", {
    "inkscape:label": "Layer 1",
    "inkscape:groupmode": "layer",
    id: "layer1",
    transform: "translate(83.366727,-146.73149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -79.251225,148.83333 c 0,1.11231 -0.9017,2.01366 -2.013656,2.01366 -1.112308,0 -2.013655,-0.90135 -2.013655,-2.01366 0,-1.11195 0.901347,-2.01365 2.013655,-2.01365 1.111956,0 2.013656,0.9017 2.013656,2.01365 z",
    style: {
      fill: "none",
      stroke: "#656263",
      strokeWidth: 0.17638148,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path768",
    "inkscape:connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -81.294161,149.81123 c 0.03563,0.0483 0.108655,0.0452 0.140758,-0.006 0,0 2.011892,-2.915 1.874661,-2.98485 -0.105128,-0.0536 -1.876072,1.96673 -1.876072,1.96673 -0.03916,0.0409 -0.09948,0.0536 -0.151695,0.031 0,0 -0.89923,-0.86113 -0.963436,-0.78952 -0.104775,0.11712 0.975784,1.78223 0.975784,1.78223",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    id: "path770",
    "inkscape:connector-curvature": 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked_icon.84081c2a94f00d8fc70c490b11409195.svg";
export { ForwardRef as ReactComponent };